var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "posters-nav-component", class: _vm.className },
    [
      _c(
        "div",
        { staticClass: "row m-b-10" },
        _vm._l(_vm.sortedPostersListKeys, function(i) {
          return _c(
            "div",
            { key: i, staticClass: "col-md-4" },
            [
              i === "own" && !_vm.posters_list[i].sm
                ? _c("upload-image", {
                    attrs: { uid: _vm.own_image_uid, holder: _vm.holder },
                    on: { onComplete: _vm.setOwnPoster }
                  })
                : _c(
                    "div",
                    {
                      class: [
                        "poster-img-container",
                        _vm.video.status.toLowerCase()
                      ]
                    },
                    [
                      i !== "own" && _vm.isAutoGenPosterProcessing
                        ? _c("div", { staticClass: "fa fa-spin fa-spinner" })
                        : _vm._e(),
                      _vm._v(" "),
                      i === "own" || _vm.isAutoGenPosterComplete
                        ? _c(
                            "div",
                            {
                              staticClass: "poster-img",
                              on: {
                                click: function($event) {
                                  _vm.$refs["poster_index_" + i][0].click()
                                }
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.poster_index,
                                    expression: "poster_index"
                                  }
                                ],
                                ref: "poster_index_" + i,
                                refInFor: true,
                                staticClass: "poster-index-input",
                                attrs: { type: "radio" },
                                domProps: {
                                  value: i,
                                  checked: _vm._q(_vm.poster_index, i)
                                },
                                on: {
                                  change: function($event) {
                                    _vm.poster_index = i
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.poster_index === i
                                ? _c("i", {
                                    staticClass: "fa fa-check poster-mark"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              i === "own"
                                ? _c("div", {
                                    staticClass: "fa fa-trash poster-remove",
                                    attrs: { title: "Remove this thumbnail" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.removeOwnPoster(i)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.posters_list[i].sm
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.posters_list[i].sm,
                                      alt: "thumbnail"
                                    }
                                  })
                                : i === "own"
                                ? _c("img", {
                                    staticClass: "temp-img-preview",
                                    attrs: { src: _vm.ownImage.url }
                                  })
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectTimelineMode,
            expression: "selectTimelineMode"
          }
        ],
        staticClass: "styled-checkbox",
        attrs: {
          id: "stream_plus",
          type: "checkbox",
          disabled: !_vm.mainValidForVideoTag
        },
        domProps: {
          checked: Array.isArray(_vm.selectTimelineMode)
            ? _vm._i(_vm.selectTimelineMode, null) > -1
            : _vm.selectTimelineMode
        },
        on: {
          change: function($event) {
            var $$a = _vm.selectTimelineMode,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.selectTimelineMode = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.selectTimelineMode = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectTimelineMode = $$c
            }
          }
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "purchase-label", attrs: { for: "stream_plus" } },
        [_vm._v("Pick thumbnail from timeline")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }